import { render, staticRenderFns } from "./form-popup.vue?vue&type=template&id=a61bbf9c&scoped=true"
import script from "./form-popup.vue?vue&type=script&lang=ts"
export * from "./form-popup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61bbf9c",
  null
  
)

export default component.exports